import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {ProductsTeaserComponent} from './products-teaser.component'
import {CarouselModule, MediaModule} from '@spartacus/storefront'
import {MbI18nModule} from '../../../translations/mb-i18n.module'
import {SafeHtmlModule} from '../../../cms/pipes/sanitize-html/safe-html.module'
import {RouterModule} from '@angular/router'
import {AnalyticsModule} from '../../../analytics/analytics.module'
import {SharedModule} from '../../shared.module';

@NgModule({
  providers: [],
  declarations: [ProductsTeaserComponent],
    imports: [
        CommonModule,
        CarouselModule,
        MbI18nModule,
        MediaModule,
        SafeHtmlModule,
        RouterModule,
        AnalyticsModule,
        SharedModule
    ],
  exports: [ProductsTeaserComponent]
})
export class ProductsTeaserModule { }
